<template lang="html">
	<div class="kvContainer">
		<div id="slider" class="mui-slider" >
			<!-- 只有一张图 -->
			<div class="imgContainer" v-show="kvArray.length == 1" v-for="(item, index) in kvArray" v-if="index == 0">
				<a v-bind:href="item.LINK_URL">
					<img v-bind:src="imgSrc+item.PIC_URL.split('|')[0]" />
					<!-- <img src="../../assets/img/yuantiao.jpg"> -->
				</a>
			</div>
			<div class="mui-slider-group mui-slider-loop" v-show="kvArray.length > 1">
				<!-- 额外增加的一个节点(循环轮播：第一个节点是最后一张轮播) -->
				<div class="mui-slider-item mui-slider-item-duplicate imgContainer" v-for="(item, index) in kvArray" v-if="index ==  kvArray.length-1">
					<a  v-bind:href="item.LINK_URL">
						<img v-bind:src="imgSrc+item.PIC_URL.split('|')[0]" />
						<!-- <img src="../../assets/img/yuantiao.jpg"> -->
					</a>
				</div>
				
				<div class="mui-slider-item imgContainer" v-for="(item, index) in kvArray" v-bind:key="index">
					<a  v-bind:href="item.LINK_URL">
						<img v-bind:src="imgSrc+item.PIC_URL.split('|')[0]" />
						<!-- <img src="../../assets/img/yuantiao.jpg"> -->
					</a>
				</div>
				
				<!-- 额外增加的一个节点(循环轮播：最后一个节点是第一张轮播) -->
				<div class="mui-slider-item mui-slider-item-duplicate imgContainer" v-for="(item, index) in kvArray" v-if="index == 0">
					<a  v-bind:href="item.LINK_URL">
						<img v-bind:src="imgSrc+item.PIC_URL.split('|')[0]" />
						<!-- <img src="../../assets/img/yuantiao.jpg"> -->
					</a>
				</div>
			</div>
			<div class="mui-slider-indicator" v-show="kvArray.length > 1">
				<div class="mui-indicator" v-for="(item, index) in kvArray" v-bind:key="index" v-bind:class="[index == 0? 'mui-active' : '' ]"></div>
			</div>
		</div>
	</div>
</template>
<script>
	import {commonPicUrl} from '../../common/url.js'
	export default {
	  	name: 'ListKv',
	  	data(){
		  	return{
		  		imgSrc:commonPicUrl,	
		  	}
	  	},
	  	props:['kvArray'],
	  	methods:{
	  		//
	  	},
	  	mounted(){
	  		this.mui.init({
				swipeBack:true //启用右滑关闭功能
			});
	  	},
	  	updated() {
	  		var slider = this.mui("#slider");
  			slider.slider({
				interval: 3000
			});
	  	},
	}
</script>
<style lang="less" scoped>
	.kvContainer{
		padding:0px 40px;
		width:100%;
		margin-top:150px;
		.imgContainer{
			width:100%;
			border-radius:10px;
			overflow:hidden;
			img{
				width:100%;	
				height:340px;
			}
		}
		.mui-slider{
			text-align:center;
			margin:10px 0;
			.mui-slider-indicator{
				position:static!important;
				margin-top:20px;
				height:25px!important;
			}
			.mui-indicator{
				width:14px!important;
				height:14px!important;
				background:#b9b9b9!important;
			}
			.mui-active{
				background:#ad8f5a!important;
			}
			.none{
				display:none!important;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/common/listKv.vue